import {defineAsyncComponent} from 'vue'
const SettlementRouter = [
  {
    path: 'settlement_rules',
    name: 'SettlementRules',
    component: () => import('@/views/Settlements/SettlementRules/Index.vue'),
    meta: {
      key: 'settlement'
    }
  },
  {
    path: 'settlement_create_rules',
    name: 'SettlementCreateRules',
    component: () => import('@/views/Settlements/SettlementRules/SettlementCreateRules.vue'),
    meta: {
      key: 'settlement'
    }
  },
  {
    path: 'settlement_profit',
    name: 'SettlementProfit',
    component: () => import('@/views/Settlements/SettlementProfit/Index.vue'),
    meta: {
      key: 'settlement'
    }
  },
  {
    path: 'settlement_uploadprofit',
    name: 'UploadProfit',
    component: () => import('@/views/Settlements/SettlementProfit/UploadProfit.vue'),
    meta: {
      key: 'settlement'
    }
  },
  {
    path: 'settlement_createpayment',
    name: 'CreatePayment',
    component: () => import('@/views/Settlements/SettlementProfit/CreatePayment.vue'),
    meta: {
      key: 'settlement'
    }
  },
  {
    path: 'settlement_activity',
    name: 'SettlementActivity',
    component: () => import('@/views/Settlements/SettlementActivity/Index.vue'),
    meta: {
      key: 'settlement'
    }
  },
  {
    path: 'settlement_uploadactivityprofit',
    name: 'UploadActivityProfit',
    component: () => import('@/views/Settlements/SettlementActivity/UploadActivityProfit.vue'),
    meta: {
      key: 'settlement'
    }
  },
]
export {SettlementRouter}
